/**
 * Kamus namespace `common` — chrome yang dipakai di banyak layar.
 * `id` = SUMBER KEBENARAN; `en` mengikuti tiering `design/I18N.md`.
 */
export const commonId = {
  save: 'Simpan',
  cancel: 'Batal',
  close: 'Tutup',
  retry: 'Coba lagi',
  loading: 'Memuat…',
  empty: 'Belum ada data',
  language: 'Bahasa',
  theme: 'Tema',
  themeSystem: 'Sistem',
  themeLight: 'Terang',
  themeDark: 'Gelap',
  back: 'Hapus',
  /* ⚠️ "Ganti orang", bukan "Keluar": layar dapur & kasir tak pernah benar-benar ditinggalkan —
     yang berganti shift-nya orang, perangkatnya tetap menyala di tempat yang sama. */
  logout: 'Ganti orang',
  /* ⛔ Bukan "memuat": keadaan ini bisa bertahan, dan yang membacanya harus tahu ia TERHENTI. */
  noBusinessDate: 'Tanggal usaha belum bisa dibaca dari server — terminal ini belum boleh berjualan',
  /* ⚠️ Dua pesan berbeda: yang satu sementara, yang satu keputusan. Menyamakannya membuat orang
     menunggu sesuatu yang tak akan datang. */
  deviceUnknown: 'Perangkat ini belum dikenali server — periksa tokennya, lalu muat ulang',
  deviceNoShell: 'Peran perangkat ini belum punya layar. Ubah perannya di portal (layar Lantai).',
};
export const commonEn: typeof commonId = {
  save: 'Save',
  cancel: 'Cancel',
  close: 'Close',
  retry: 'Retry',
  loading: 'Loading…',
  empty: 'No data yet',
  back: 'Delete',
  language: 'Language',
  theme: 'Theme',
  themeSystem: 'System',
  themeLight: 'Light',
  themeDark: 'Dark',
  logout: 'Switch user',
  noBusinessDate: 'The business date could not be read from the server — this terminal cannot sell yet',
  deviceUnknown: 'This device is not recognised by the server — check its token, then reload',
  deviceNoShell: 'This device role has no screen yet. Change its role in the portal (Floor screen).',
};
